import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsDivider } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VSheet,
    { staticClass: "mx-md-5 mx-2" },
    [
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [_c("router-view", { on: { showParent: _vm.showParent } })],
        1
      ),
      _vm.showParentPage
        ? _c(
            "div",
            [
              _c(
                VBreadcrumbs,
                { staticClass: "d-print-none" },
                [
                  _c(
                    VBreadcrumbsItem,
                    {
                      attrs: { exact: true, to: { name: "home", params: {} } },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$vuetify.lang.t("$vuetify.sideBar.home"))
                      ),
                    ]
                  ),
                  _c(VBreadcrumbsDivider, [_vm._v("/")]),
                  _c(
                    VBreadcrumbsItem,
                    {
                      attrs: {
                        exact: true,
                        to: { name: "inventorySelection", params: {} },
                        active: "",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$vuetify.lang.t(
                              "$vuetify.sideBar.inventorySelection"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                VExpansionPanels,
                {
                  staticClass: "d-print-none",
                  model: {
                    value: _vm.showSearch,
                    callback: function ($$v) {
                      _vm.showSearch = $$v
                    },
                    expression: "showSearch",
                  },
                },
                [
                  _c(
                    VExpansionPanel,
                    [
                      _c(
                        VExpansionPanelHeader,
                        { staticClass: "d-flex justify-space-between" },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column flex-md-row" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$vuetify.lang.t("$vuetify.base.search")
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        VExpansionPanelContent,
                        [
                          _c(
                            VSheet,
                            { staticClass: "d-flex flex-column" },
                            [
                              _c("page-params", {
                                attrs: {
                                  pageName: "inventorySelection",
                                  vuexName: "labSearchParameters",
                                  parameters: _vm.parameters,
                                },
                                on: {
                                  onLoad: function ($event) {
                                    _vm.getSelectedProductSpecs()
                                    _vm.search()
                                  },
                                },
                              }),
                              _c(VDivider),
                              _c("div", { staticClass: "my-5" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-flex justify-space-between",
                                  },
                                  [
                                    _c(VAutocomplete, {
                                      key: _vm.ts,
                                      attrs: {
                                        label: "Choose a target product",
                                        "return-object": "",
                                        items: _vm.productSpecsList,
                                        "item-text": "productName",
                                        "item-value": "productId",
                                        clearable: "",
                                        outlined: "",
                                        "hide-details": "",
                                      },
                                      on: {
                                        input: _vm.getSelectedProductSpecs,
                                      },
                                      model: {
                                        value: _vm.parameters.targetProduct,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.parameters,
                                            "targetProduct",
                                            $$v
                                          )
                                        },
                                        expression: "parameters.targetProduct",
                                      },
                                    }),
                                    _c(
                                      VMenu,
                                      {
                                        attrs: { "offset-y": "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on, attrs }) {
                                                return [
                                                  _c(
                                                    VBtn,
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass: "ml-2",
                                                          attrs: { icon: "" },
                                                        },
                                                        "v-btn",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c(VIcon, [
                                                        _vm._v(
                                                          "mdi-dots-vertical"
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3373953352
                                        ),
                                      },
                                      [
                                        _c(
                                          VList,
                                          { staticClass: "pa-5" },
                                          [
                                            _c(
                                              VListItem,
                                              {
                                                attrs: {
                                                  to: { name: "productSpecs" },
                                                },
                                              },
                                              [
                                                _c(VListItemContent, [
                                                  _vm._v(" Review All "),
                                                ]),
                                              ],
                                              1
                                            ),
                                            _vm.productSpecs &&
                                            _vm.parameters.targetProduct
                                              ? _c(
                                                  VListItem,
                                                  {
                                                    attrs: {
                                                      to: {
                                                        name: "productSpecsEdit",
                                                        params: {
                                                          id: _vm.productSpecs
                                                            .id,
                                                        },
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(VListItemContent, [
                                                      _vm._v(
                                                        " Edit " +
                                                          _vm._s(
                                                            _vm.parameters
                                                              .targetProduct
                                                              .productName
                                                          ) +
                                                          " Specifications "
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            !_vm.productSpecs &&
                                            _vm.parameters.targetProduct
                                              ? _c(
                                                  VListItem,
                                                  {
                                                    attrs: {
                                                      to: {
                                                        name: "productSpecsCreate",
                                                        params: {
                                                          productId:
                                                            _vm.parameters
                                                              .targetProduct
                                                              .productId,
                                                        },
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(VListItemContent, [
                                                      _vm._v(
                                                        " Define " +
                                                          _vm._s(
                                                            _vm.parameters
                                                              .targetProduct
                                                              .productName
                                                          ) +
                                                          " Specifications "
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c(
                                VExpansionPanels,
                                {
                                  model: {
                                    value: _vm.showSearchCriteria,
                                    callback: function ($$v) {
                                      _vm.showSearchCriteria = $$v
                                    },
                                    expression: "showSearchCriteria",
                                  },
                                },
                                [
                                  _c(
                                    VExpansionPanel,
                                    [
                                      _c(
                                        VExpansionPanelHeader,
                                        {
                                          staticClass:
                                            "d-flex justify-space-between",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex flex-column flex-md-row",
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "mb-2 mb-md-0" },
                                                [_vm._v("Edit search criteria")]
                                              ),
                                              _c(VDivider, {
                                                staticClass: "mx-4",
                                                attrs: { vertical: "" },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "font-weight-light",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.criteriaText)
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _c(
                                        VExpansionPanelContent,
                                        [
                                          _vm._l(
                                            _vm.parameters.operations,
                                            function (operation, index) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index,
                                                  staticClass:
                                                    "d-flex flex-column flex-md-row justify-space-between",
                                                },
                                                [
                                                  _c(VAutocomplete, {
                                                    attrs: {
                                                      items: _vm.labElements,
                                                      "item-text": "symbol",
                                                      "item-value": "id",
                                                      label: "Element",
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.updateCriteriaText(
                                                          _vm.parameters
                                                            .operations
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        operation.elementId,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          operation,
                                                          "elementId",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "operation.elementId",
                                                    },
                                                  }),
                                                  _c(
                                                    VBtnToggle,
                                                    {
                                                      staticClass:
                                                        "mx-auto mx-md-10",
                                                      attrs: { rounded: "" },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.updateCriteriaText(
                                                            _vm.parameters
                                                              .operations
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          operation.operator,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            operation,
                                                            "operator",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "operation.operator",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        VBtn,
                                                        {
                                                          attrs: {
                                                            value: "gt",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            VIcon,
                                                            {
                                                              attrs: {
                                                                small: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-greater-than"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        VBtn,
                                                        {
                                                          attrs: {
                                                            value: "ge",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            VIcon,
                                                            {
                                                              attrs: {
                                                                small: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-greater-than-or-equal"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        VBtn,
                                                        {
                                                          attrs: {
                                                            value: "eq",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            VIcon,
                                                            {
                                                              attrs: {
                                                                small: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-equal"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        VBtn,
                                                        {
                                                          attrs: {
                                                            value: "le",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            VIcon,
                                                            {
                                                              attrs: {
                                                                small: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-less-than-or-equal"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        VBtn,
                                                        {
                                                          attrs: {
                                                            value: "lt",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            VIcon,
                                                            {
                                                              attrs: {
                                                                small: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-less-than"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(VTextField, {
                                                    attrs: { label: "Value" },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.updateCriteriaText(
                                                          _vm.parameters
                                                            .operations
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: operation.value,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          operation,
                                                          "value",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "operation.value",
                                                    },
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "text-right",
                                                    },
                                                    [
                                                      _vm.parameters.operations
                                                        .length > 1
                                                        ? _c(
                                                            VBtn,
                                                            {
                                                              staticClass:
                                                                "mt-5",
                                                              attrs: {
                                                                icon: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.parameters.operations.splice(
                                                                      index,
                                                                      1
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(VIcon, [
                                                                _vm._v(
                                                                  "mdi-delete-outline"
                                                                ),
                                                              ]),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _c(VDivider, {
                                                        staticClass:
                                                          "d-flex d-md-none",
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "d-flex justify-end",
                                            },
                                            [
                                              _c(
                                                VBtn,
                                                {
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.parameters.operations.push(
                                                        {}
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Add Criteria")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                VRadioGroup,
                                                {
                                                  attrs: {
                                                    label:
                                                      "Include inventory status",
                                                    row: "",
                                                    "hide-details": "",
                                                    dense: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.parameters
                                                        .inventoryStatus,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.parameters,
                                                        "inventoryStatus",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "parameters.inventoryStatus",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.inventoryStatuses,
                                                  function (status, index) {
                                                    return _c(VRadio, {
                                                      key: index,
                                                      attrs: {
                                                        label: status.label,
                                                        value: status.value,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "my-4" },
                                            [
                                              _c("product-select", {
                                                key: _vm.ts,
                                                attrs: {
                                                  label:
                                                    "Filter results by products",
                                                  multiple: "",
                                                  "return-object": "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.parameters
                                                      .filterProducts,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.parameters,
                                                      "filterProducts",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "parameters.filterProducts",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "d-flex justify-center mt-10" },
                                [
                                  _c(
                                    VBtn,
                                    {
                                      attrs: {
                                        color: "primary",
                                        loading: _vm.loadingData,
                                      },
                                      on: { click: _vm.search },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$vuetify.lang.t(
                                            "$vuetify.base.submit"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(VProgressLinear, {
                attrs: {
                  indeterminate: "",
                  color: "primary",
                  active: _vm.loadingData,
                },
              }),
              _vm.inventoryList && _vm.inventoryList.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "table-container",
                      attrs: { id: "resultPanel" },
                    },
                    [
                      _c(VDivider, { staticClass: "my-5" }),
                      _c(
                        "div",
                        {
                          staticClass:
                            "my-2 d-flex justify-space-around d-print-none",
                        },
                        [
                          _c(
                            VBtn,
                            {
                              directives: [
                                {
                                  name: "print",
                                  rawName: "v-print",
                                  value: _vm.resultPanel,
                                  expression: "resultPanel",
                                },
                              ],
                            },
                            [_vm._v(" Print ")]
                          ),
                          _vm.filteredInventoryList &&
                          _vm.filteredInventoryList.length > 0
                            ? _c("download", {
                                attrs: { fileName: "CoA-Inventory-Selection" },
                                model: {
                                  value: _vm.filteredInventoryList,
                                  callback: function ($$v) {
                                    _vm.filteredInventoryList = $$v
                                  },
                                  expression: "filteredInventoryList",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm.isMobile
                        ? _c(
                            "div",
                            { staticClass: "ma-5" },
                            [
                              _c(
                                VMenu,
                                {
                                  attrs: { "z-index": "99" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              VBtn,
                                              _vm._g(
                                                _vm._b(
                                                  { attrs: { width: "100%" } },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _vm._v(" Filter Results "),
                                                _c(
                                                  VIcon,
                                                  { attrs: { right: "" } },
                                                  [_vm._v("mdi-filter-variant")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2219314324
                                  ),
                                },
                                [
                                  _c(
                                    VList,
                                    { staticClass: "pa-5" },
                                    [
                                      _c(VCheckbox, {
                                        attrs: {
                                          label: "Selected Only",
                                          "hide-details": "",
                                          value: "selectedOnly",
                                        },
                                        model: {
                                          value: _vm.filterSelection,
                                          callback: function ($$v) {
                                            _vm.filterSelection = $$v
                                          },
                                          expression: "filterSelection",
                                        },
                                      }),
                                      _c(VCheckbox, {
                                        attrs: {
                                          label: "Unselected Only",
                                          "hide-details": "",
                                          value: "unselectedOnly",
                                        },
                                        model: {
                                          value: _vm.filterSelection,
                                          callback: function ($$v) {
                                            _vm.filterSelection = $$v
                                          },
                                          expression: "filterSelection",
                                        },
                                      }),
                                      _c(VDivider),
                                      _c(
                                        VRadioGroup,
                                        {
                                          model: {
                                            value: _vm.filterSelection,
                                            callback: function ($$v) {
                                              _vm.filterSelection = $$v
                                            },
                                            expression: "filterSelection",
                                          },
                                        },
                                        [
                                          _c(VRadio, {
                                            attrs: {
                                              label: "Select All",
                                              value: "selectAll",
                                            },
                                          }),
                                          _c(VRadio, {
                                            attrs: {
                                              label: "Unselected All",
                                              value: "unselectAll",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        VDataTable,
                        {
                          staticClass: "elevation-1 my-5",
                          attrs: {
                            id: "selection-results",
                            headers: _vm.headers,
                            items: _vm.filteredInventoryList,
                            "items-per-page": _vm.pagination.pageSize,
                            loading: _vm.isAppLoading,
                            page: _vm.pagination.current,
                            "item-key": "id",
                            "disable-pagination": true,
                            "hide-default-footer": true,
                            height: "90vh",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header.selected",
                                fn: function ({}) {
                                  return [
                                    !_vm.isMobile
                                      ? _c(
                                          VMenu,
                                          {
                                            attrs: { "offset-y": "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        VBtn,
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              attrs: {
                                                                icon: "",
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(VIcon, [
                                                            _vm._v(
                                                              "mdi-filter-variant"
                                                            ),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c(
                                              VList,
                                              { staticClass: "pa-5" },
                                              [
                                                _c(VCheckbox, {
                                                  attrs: {
                                                    label: "Selected Only",
                                                    "hide-details": "",
                                                    value: "selectedOnly",
                                                  },
                                                  model: {
                                                    value: _vm.filterSelection,
                                                    callback: function ($$v) {
                                                      _vm.filterSelection = $$v
                                                    },
                                                    expression:
                                                      "filterSelection",
                                                  },
                                                }),
                                                _c(VCheckbox, {
                                                  attrs: {
                                                    label: "Unselected Only",
                                                    "hide-details": "",
                                                    value: "unselectedOnly",
                                                  },
                                                  model: {
                                                    value: _vm.filterSelection,
                                                    callback: function ($$v) {
                                                      _vm.filterSelection = $$v
                                                    },
                                                    expression:
                                                      "filterSelection",
                                                  },
                                                }),
                                                _c(VDivider),
                                                _c(
                                                  VRadioGroup,
                                                  {
                                                    model: {
                                                      value:
                                                        _vm.filterSelection,
                                                      callback: function ($$v) {
                                                        _vm.filterSelection =
                                                          $$v
                                                      },
                                                      expression:
                                                        "filterSelection",
                                                    },
                                                  },
                                                  [
                                                    _c(VRadio, {
                                                      attrs: {
                                                        label: "Select All",
                                                        value: "selectAll",
                                                      },
                                                    }),
                                                    _c(VRadio, {
                                                      attrs: {
                                                        label: "Unselected All",
                                                        value: "unselectAll",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "header.documentNo",
                                fn: function ({}) {
                                  return [
                                    _c(VTextField, {
                                      staticClass: "mr-2",
                                      staticStyle: {
                                        "font-size": "small",
                                        "min-width": "110px",
                                      },
                                      attrs: {
                                        placeholder: "Document No",
                                        outlined: "",
                                        clearable: "",
                                        dense: "",
                                        "hide-details": "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          $event.stopPropagation()
                                        },
                                      },
                                      model: {
                                        value: _vm.documentNoFilter,
                                        callback: function ($$v) {
                                          _vm.documentNoFilter = $$v
                                        },
                                        expression: "documentNoFilter",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.selected",
                                fn: function ({ item }) {
                                  return [
                                    _c(VSimpleCheckbox, {
                                      key: item.selected,
                                      staticClass: "ml-1",
                                      attrs: { ripple: false, value: true },
                                      on: {
                                        click: function ($event) {
                                          _vm.checkedInventory(item)
                                          _vm.summarize()
                                        },
                                      },
                                      model: {
                                        value: item.selected,
                                        callback: function ($$v) {
                                          _vm.$set(item, "selected", $$v)
                                        },
                                        expression: "item.selected",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.documentNo",
                                fn: function ({ item }) {
                                  return [
                                    item.inventoryId
                                      ? _c(
                                          "a",
                                          {
                                            on: {
                                              click: function ($event) {
                                                _vm.lookupInventory = true
                                                _vm.selectedInventory =
                                                  item.inventoryId
                                              },
                                            },
                                          },
                                          [
                                            _vm.documentNoFilter
                                              ? _c(
                                                  "text-highlight",
                                                  {
                                                    attrs: {
                                                      queries:
                                                        _vm.documentNoFilter,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.documentNo)
                                                    ),
                                                  ]
                                                )
                                              : _c("span", [
                                                  _vm._v(
                                                    _vm._s(item.documentNo)
                                                  ),
                                                ]),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "item.inventory.stockTime",
                                fn: function ({ item }) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("formatDateYear")(
                                            item.inventory
                                              ? item.inventory.stockTime
                                              : null
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.use",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "div",
                                      { staticStyle: { width: "100px" } },
                                      [
                                        _c(VTextField, {
                                          staticClass: "shrink my-2",
                                          attrs: {
                                            disabled: !item.selected,
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                          },
                                          on: { change: _vm.summarize },
                                          model: {
                                            value: item.use,
                                            callback: function ($$v) {
                                              _vm.$set(item, "use", $$v)
                                            },
                                            expression: "item.use",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.inventory.quantityAvailable",
                                fn: function ({ item }) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("formatNumber")(
                                            item.inventory
                                              ? item.inventory.quantityAvailable
                                              : null
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.inventory.unitAvailable",
                                fn: function ({ item }) {
                                  return [
                                    _c("inventory-unit-details", {
                                      key: item.inventory.id,
                                      attrs: {
                                        count: item.inventory.unitAvailable,
                                        mode: "selection",
                                      },
                                      on: {
                                        selectionChanged: function ($event) {
                                          return _vm.updateUse(item, $event)
                                        },
                                      },
                                      model: {
                                        value: item.inventory.id,
                                        callback: function ($$v) {
                                          _vm.$set(item.inventory, "id", $$v)
                                        },
                                        expression: "item.inventory.id",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2343764165
                          ),
                        },
                        [
                          _c("template", { slot: "body.append" }, [
                            _vm.isMobile && _vm.selectedTotal
                              ? _c(
                                  "tr",
                                  {
                                    staticClass:
                                      "v-data-table__mobile-table-row",
                                  },
                                  [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "v-data-table__mobile-row",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "v-data-table__mobile-row__header",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  this.$vuetify.lang.t(
                                                    "$vuetify.worksheet.selectedUnit"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "v-data-table__mobile-row__cell",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("formatNumber")(
                                                    _vm._f("sum")(
                                                      _vm.selectedTotal.units
                                                    )
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "v-data-table__mobile-row",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "v-data-table__mobile-row__header",
                                          },
                                          [_vm._v("Selected Use")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "v-data-table__mobile-row__cell",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("formatNumber")(
                                                    _vm._f("sum")(
                                                      _vm.selectedTotal.use
                                                    )
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "v-data-table__mobile-row",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "v-data-table__mobile-row__header",
                                          },
                                          [_vm._v(" Selected Quantity ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "v-data-table__mobile-row__cell",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("formatNumber")(
                                                    _vm._f("sum")(
                                                      _vm.selectedTotal
                                                        .quantities
                                                    )
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm.productSpecs
                                      ? _vm._l(
                                          _vm.productSpecs.elements,
                                          function (e) {
                                            return _c(
                                              "td",
                                              {
                                                key: e.id,
                                                staticClass:
                                                  "v-data-table__mobile-row",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "v-data-table__mobile-row__header",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          e.element.elementName
                                                        ) +
                                                        " (" +
                                                        _vm._s(
                                                          e.element.symbol
                                                        ) +
                                                        ") "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "v-data-table__mobile-row__cell",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "negativeNumber"
                                                          )(
                                                            _vm.weightedAvg(
                                                              _vm.selectedTotal[
                                                                e.element.symbol
                                                              ]
                                                            )
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm.selectedTotal && !_vm.isMobile
                              ? _c(
                                  "tr",
                                  { staticClass: "table-summary" },
                                  [
                                    _c("td", { attrs: { colspan: "2" } }, [
                                      _vm._v("Selected Total"),
                                    ]),
                                    _c("td", { attrs: { colspan: "2" } }),
                                    _c("td", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("formatNumber")(
                                              _vm._f("sum")(
                                                _vm.selectedTotal.units
                                              )
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("td", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("formatNumber")(
                                              _vm._f("sum")(
                                                _vm.selectedTotal.use
                                              )
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("td", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("formatNumber")(
                                              _vm._f("sum")(
                                                _vm.selectedTotal.quantities
                                              )
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _vm.productSpecs
                                      ? _vm._l(
                                          _vm.productSpecs.elements,
                                          function (e) {
                                            return _c("td", { key: e.id }, [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("negativeNumber")(
                                                      _vm.weightedAvg(
                                                        _vm.selectedTotal[
                                                          e.element.symbol
                                                        ]
                                                      )
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ])
                                          }
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            !_vm.isMobile
                              ? _c(
                                  "tr",
                                  { staticClass: "table-summary" },
                                  [
                                    _c("td", { attrs: { colspan: "2" } }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.parameters.targetProduct
                                              ? _vm.parameters.targetProduct
                                                  .productName
                                              : ""
                                          ) +
                                          " Target "
                                      ),
                                    ]),
                                    _c("td", { attrs: { colspan: "2" } }),
                                    _c("td", [
                                      _c(
                                        "div",
                                        { staticStyle: { width: "100px" } },
                                        [
                                          _c(VTextField, {
                                            staticClass: "shrink my-2",
                                            attrs: {
                                              outlined: "",
                                              dense: "",
                                              "hide-details": "",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _c("td", [_vm._v("0")]),
                                    _c("td", [_vm._v("0")]),
                                    _vm.productSpecs
                                      ? _vm._l(
                                          _vm.productSpecs.elements,
                                          function (e) {
                                            return _c("td", { key: e.id }, [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.productSpecs[
                                                      e.element.symbol
                                                    ]
                                                  ) +
                                                  " "
                                              ),
                                            ])
                                          }
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c("confirmation-dialog", { ref: "confirm" }),
      _c(
        VBottomSheet,
        {
          attrs: { scrollable: "" },
          model: {
            value: _vm.lookupInventory,
            callback: function ($$v) {
              _vm.lookupInventory = $$v
            },
            expression: "lookupInventory",
          },
        },
        [
          _c(
            VCard,
            [
              _c(
                VCardActions,
                { staticClass: "justify-center" },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "mt-6",
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.lookupInventory = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.close")) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                VCardText,
                [
                  _c("inventory-details", {
                    key: _vm.selectedInventory,
                    model: {
                      value: _vm.selectedInventory,
                      callback: function ($$v) {
                        _vm.selectedInventory = $$v
                      },
                      expression: "selectedInventory",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }